import { useSelector, useDispatch } from "react-redux";
import { pageActions } from "../store/page";

const usePage = () => {
  const dispatch = useDispatch();

  const isShown = useSelector((state) => state.page.show);
  const message = useSelector((state) => state.page.message);
  const status = useSelector((state) => state.page.status);

  const showMessage = (message, status) => {
    dispatch(pageActions.showMessage({ message, status }));
  };

  return { showMessage, isShown, message, status };
};

export default usePage;
